import React from 'react';

import { Divider, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { AddObjective } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';
import { ArrowThickLeftIcon, ArrowThickRightIcon } from 'constants/icons';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';
import { TextLabelSmall } from 'uiToolkitV1/Typography/Typography';

const CardWrapper = styled.div`
  margin-top: 18px;
  width: 300px;
  background: ${(props) => props.theme.colors.surface.FAFAFA};
  border-radius: 4px;
  position: relative;
`;

const ExpandCollapseWrapper = styled.div`
  position: absolute;
  right: -32px;
  top: 28px;
`;

const OptionsWrapper = styled.div`
  position: absolute;
  right: -1px;
  bottom: -32px;
`;

const ExpandCollapseButton = ({ isExpanded, onClick }) => {
  const Icon = () => (isExpanded ? <ArrowThickLeftIcon size="fixed10px" /> : <ArrowThickRightIcon size="fixed10px" />);
  return <CircularOutlineIcon onClick={() => onClick(!isExpanded)} color="primary" icon={Icon} />;
};

const RootNode = ({ onObjectiveCreationClick, onExpandClick, isExpanded, enableObjectiveCreation = false }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  return (
    <CardWrapper>
      <Flex alignItems="flex-start" direction="column" justifyContent="center" padding="12px">
        <TextLabel bold>{`${moduleName} Tree`}</TextLabel>
        <TextLabelSmall>{`Create or view all your ${modifyString(
          keyResultsName,
          StringModifier.PLURAL_SENTENCE_CASE
        )} across ${modifyString(objectivesName, StringModifier.PLURAL_SENTENCE_CASE)}`}</TextLabelSmall>
      </Flex>
      {enableObjectiveCreation && (
        <>
          <Divider />
          <Flex justifyContent="flex-end">
            <Button onClick={onObjectiveCreationClick} variant="tertiary" StartIcon={AddObjective} />
          </Flex>
        </>
      )}
    </CardWrapper>
  );
};

export default RootNode;
